import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import Loading from "../../components/Common/Loading";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

function Faq(props) {
  const [faqs, setFaqs] = useState([
    {
      question: "",
      answer: "",
    },
  ]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const allFields = watch();
  const user = useSelector((state) => state.User);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // console.log("user", user);

  // get faqs
  const getFaqs = () => {
    setIsLoading(true);
    apiReq(url.GET_FAQ, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setFaqs(res.data.items);
          setValue("title", res.data.title);
          setValue("description", res.data.description);
          setValue("meta_title", res.data.meta_title);
          setValue("meta_description", res.data.meta_description);

          setIsEmpty(false);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setIsEmpty(true);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getFaqs();
  }, []);

  // Todo: Create faq first time
  const createFaq = (data) => {
    if (isEmpty) {
      if (faqs[0].question === "" || faqs[0].answer === "") {
        Swal.fire({
          title: "Error",
          text: "Please fill the question and answer",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        setIsLoading(true);
        apiReq(
          url.CREATE_FAQ,
          {
            title: data.title,
            description: data.description,
            items: faqs,
            meta_title: data.meta_title,
            meta_description: data.meta_description,
          },
          "post",
          {
            Authorization: `Bearer ${user.user?.token}`,
          }
        )
          .then((res) => {
            setIsEmpty(false);
            setIsLoading(false);
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
            // console.log("res>>>", res);
          })
          .catch((err) => {
            setIsLoading(false);
            console.log("err>>>", err);
          });
      }
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_FAQ,
        {
          title: data.title,
          description: data.description,
          items: faqs,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  // Todo: Update Faq

  //Todo: addNewFaq
  const addNewFaq = () => {
    setFaqs([...faqs, { question: "", answer: "" }]);
  };

  // Todo: removeFaq
  const removeFaq = (index) => {
    const newFaqs = [...faqs];
    newFaqs.splice(index, 1);
    setFaqs(newFaqs);
  };

  // Todo: handleFaq
  const handleFaq = (e, index) => {
    const { name, value } = e.target;
    const newFaqs = [...faqs];
    newFaqs[index][name] = value;
    setFaqs(newFaqs);
  };

  // Todo: handle Faq Answer
  const handleFaqAns = (data, index) => {
    // const { name, value } = e.target;
    // const newFaqs = [...faqs];
    // newFaqs[index][answer] = data;
    // setFaqs(newFaqs);
    const newFaqs = [...faqs];
    newFaqs[index].answer = data;
    setFaqs(newFaqs);
    console.log("current faq>>", newFaqs[index].answer);
  };

  // console.log("faqs>>>", faqs);

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Faq</h5>
              <hr />
              <form onSubmit={handleSubmit(createFaq)}>
                <div className="mt-4">
                  <div className="mb-3">
                    <label>Title</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("title", { required: true })}
                      placeholder="Enter faq page title"
                    />
                    {errors.title && (
                      <span className="text-danger">Title is required</span>
                    )}
                  </div>
                  <div className="mb-3">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      placeholder="Enter description"
                      {...register("description", { required: true })}
                      style={{ resize: "none", minHeight: "130px" }}
                    ></textarea>
                    {errors.description && (
                      <span className="text-danger">
                        Description is required
                      </span>
                    )}
                  </div>
                  <div className="mt-3">
                    <label>Faqs</label>
                    <hr />
                    {faqs.length > 1 && (
                      <div>
                        {faqs.map((faq, index) => {
                          return (
                            <div key={index} className="row mb-4">
                              <div className="col-md-11">
                                <div className="mb-2">
                                  <input
                                    type="text"
                                    placeholder="Question"
                                    className="form-control"
                                    value={faq.question}
                                    name="question"
                                    onChange={(e) => handleFaq(e, index)}
                                  />
                                </div>
                                <div className="mb-0">
                                  {/* <textarea
                                    type="text"
                                    placeholder="Answer"
                                    value={faq.answer}
                                    className="form-control"
                                    name="answer"
                                    onChange={(e) => handleFaq(e, index)}
                                    style={{
                                      resize: "none",
                                      minHeight: "130px",
                                      overflow: "auto",
                                    }}
                                  /> */}

                                  <CKEditor
                                    editor={ClassicEditor}
                                    data={faq.answer}
                                    style={{ minHeight: "130px" }}
                                    onReady={(editor) => {
                                      // You can store the "editor" and use when it is needed.
                                      console.log(
                                        "Editor is ready to use!",
                                        editor
                                      );
                                    }}
                                    onChange={(event, editor) => {
                                      const data = editor.getData();
                                      handleFaqAns(data, index);
                                      // console.log({ event, editor, data });
                                    }}
                                    onBlur={(event, editor) => {
                                      console.log("Blur.", editor);
                                    }}
                                    onFocus={(event, editor) => {
                                      console.log("Focus.", editor);
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-md-1">
                                <button
                                  className="btn btn-danger"
                                  style={{ width: "100%" }}
                                  type="button"
                                  onClick={() => removeFaq(index)}
                                >
                                  <i className="ri-delete-bin-line"></i>
                                </button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                    <hr />
                    <div className="d-flex justify-content-end">
                      <button
                        className="btn btn-success"
                        onClick={addNewFaq}
                        type="button"
                      >
                        <i className="ri-add-fill"></i> Add Faq
                      </button>
                    </div>
                  </div>
                </div>
                <h5 className="mt-4">SEO Meta Tags</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Meta Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_title?.length} / 70)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_title", { required: false })}
                    placeholder="Enter title"
                  />
                </div>
                <div className="mb-3">
                  <label>
                    Meta Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_description?.length} / 200)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_description", { required: false })}
                    placeholder="Enter description"
                  />
                </div>
                <hr />
                <div>
                  <button className="btn btn-primary" type="submit">
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Faq;
